import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./editfaq.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Editfaq() {
  const { id } = useParams();
  const [loading, setLoading] = useState();
  const [category, setCategory] = useState();
  const [question, setQuestion] = useState();
  const [answer, setAnswer] = useState();
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/faqs/${id}`);
    handlesetAdd(result.data.data[0]);
    setCategory(result.data.data[0].category);
    setQuestion(result.data.data[0].question);
    setAnswer(result.data.data[0].answer);
  };

  const [add, setAdd] = useState({
    category: "",
    question: "",
    answer: "",
  });

  const handlesetAdd = (data) => {
    setAdd({
      category: data.category,
      question: data.question,
      answer: data.answer,
    });
  };

  const putFaq = async () => {
    if (
      add.category !== category ||
      add.question !== question ||
      add.answer !== answer
    ) {
      setLoading(true);
      await axios.patch(`https://mobile.amospa.com/faqs/${id}`, {
        category: category,
        question: question,
        answer: answer,
      });
      setLoading(false);
      setTitle("Success Update FAQ");
      setModalShow(true);
    } else {
      setTitle("Tidak ada Perubahan Data");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/faq");
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-edit-faq">
                <div className="header-edit-faq">
                  <h5 className="m-0">Edit Faq</h5>
                </div>
                <div className="form-edit-faq">
                  <div className="wrapper-data">
                    <label>Category</label>
                    <input
                      type="text"
                      defaultValue={category}
                      onChange={(e) => setCategory(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>Question</label>
                    <input
                      type="text"
                      defaultValue={question}
                      onChange={(e) => setQuestion(e.target.value)}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>Answer</label>
                    <input
                      type="text"
                      defaultValue={answer}
                      onChange={(e) => setAnswer(e.target.value)}
                    />
                  </div>
                  <button onClick={() => putFaq()} className=" text-white">
                    Update This Faq
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={handleNext}
      />
    </div>
  );
}

export default Editfaq;
